var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7087 8.3335H20.292L15.0837 14.5835H8.83366C7.72859 14.5835 6.66878 15.0225 5.88738 15.8039C5.10598 16.5853 4.66699 17.6451 4.66699 18.7502V37.5002C4.66699 38.6052 5.10598 39.665 5.88738 40.4464C6.66878 41.2278 7.72859 41.6668 8.83366 41.6668H42.167C43.2721 41.6668 44.3319 41.2278 45.1133 40.4464C45.8947 39.665 46.3337 38.6052 46.3337 37.5002V18.7502C46.3337 17.6451 45.8947 16.5853 45.1133 15.8039C44.3319 15.0225 43.2721 14.5835 42.167 14.5835H35.917L30.7087 8.3335Z",
    stroke: "white",
    strokeWidth: 2.85714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 33.3335C28.9518 33.3335 31.75 30.5353 31.75 27.0835C31.75 23.6317 28.9518 20.8335 25.5 20.8335C22.0482 20.8335 19.25 23.6317 19.25 27.0835C19.25 30.5353 22.0482 33.3335 25.5 33.3335Z",
    stroke: "white",
    strokeWidth: 2.85714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.6a962a037d3f1768f2ac48b85754f86d.svg";
export { ForwardRef as ReactComponent };